
export default {
  myProfile: {},
  myToken: '',
  myRefreshToken: '',
  sendNextRefreshRequestIn: new Date().getTime(),
  userPermissions: [],
  // '' (not asked yet) | 'loading' | 'loaded' | 'error' - see App.vue getUserPermissions()
  userPermissionsStatus: ''
}
